import { lazy } from 'react';

const MakePaymentConfig = {
  settings: {
    layout: {
      style: 'layout1',
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        mode: 'fullwidth',
      },
    },
  },
  routes: [
    {
      path: '/makepayment',
      component: lazy(() => import('./MakePayment')),
    },
  ],
};

export default MakePaymentConfig;
